//**
// This utility use to generate the validation rules from the form fields 
//
//**/

import { ErrorMessage } from "./../../data/appMessages";


// export const getValidationRules = (fromFields) => {

//     let valRules = {}
//     fromFields.forEach(element => {
//         if (element.validation && element.validation.length > 0) {
//             let vallist = element.validation;
//             let fieldValRules = [];
//             vallist.forEach(valItem => {
//                 let valRule = getValidationRule(element, valItem)
//                 fieldValRules.push(valRule);
//             });
//             valRules = {
//                 ...valRules,
//                 [element.dataField]: fieldValRules
//             }
//         }
//     });
//     return valRules;
// }


export const getValidationRules = (sections) => {
    let valRules = {};

    sections.forEach(section => {
        // Check if the section has rowGroup or direct fields
        if (section.rowGroup && section.rowGroup.length > 0) {
            // If rowGroup exists, loop through each rowGroup and its fields
            section.rowGroup.forEach(rowGroup => {
                rowGroup.fields.forEach(field => {
                    if (field.validation && field.validation.length > 0) {
                        let fieldValRules = field.validation.map(valItem => getValidationRule(field, valItem));
                        valRules = {
                            ...valRules,
                            [field.dataField]: fieldValRules
                        };
                    }
                });
            });
        } else if (section.fields && section.fields.length > 0) {
            // Handle sections with direct fields (no rowGroup)
            section.fields.forEach(field => {
                if (field.validation && field.validation.length > 0) {
                    let fieldValRules = field.validation.map(valItem => getValidationRule(field, valItem));
                    valRules = {
                        ...valRules,
                        [field.dataField]: fieldValRules
                    };
                }
            });
        }
    });

    return valRules;
};



// Note: Element is not use as of now
const getValidationRule = (element, validation) => {

    let valObj = {};
    switch (validation.type) {
        case "require":
            valObj = {
                type: validation.type,
                message: ErrorMessage.FieldRequired.replace('{0}', element.Field_Name)
            }
            break;
        case "email":
            valObj = {
                type: validation.type,
                message: ErrorMessage.EmailAddressNotValid
            }
            break;

        case "phoneNumber":
            valObj = {
                type: validation.type,
                message: ErrorMessage.PhoneValidation
            }
            break;
        case "password":
            valObj = {
                type: validation.type,
                message: ErrorMessage.NOTVALIDPATTERN.replace("{0}", "Password")
            }
            break;
        case 'compare':
            valObj = {
                type: validation.type,
                compareEle: validation.compareEle,
                message: ErrorMessage.CompareField.replace("{0}", element.Field_Name)
            }
            break;
        default:

        // Please Enter all the case
    }
    return valObj;

}